import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCameraPlusIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20 10.5a1.0001 1.0001 0 0 0-1 1v7a1.0001 1.0001 0 0 1-1 1H4a1.0002 1.0002 0 0 1-1-1v-8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-.68l.54-1.64a1 1 0 0 1 .95-.68H14a1 1 0 1 0 0-2H8.44A3 3 0 0 0 5.6 6.55l-.32 1H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-7a1.0001 1.0001 0 0 0-1-1.05Zm-9-1a4.0002 4.0002 0 0 0-3.9231 4.7804 3.9998 3.9998 0 0 0 5.4538 2.9151A3.9996 3.9996 0 0 0 15 13.5a3.9997 3.9997 0 0 0-4-4Zm0 6a1.9998 1.9998 0 0 1-1.8478-1.2346 2.0002 2.0002 0 0 1 1.4576-2.727A2 2 0 1 1 11 15.5Zm11-11h-1v-1a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 19 3.5v1h-1a1 1 0 1 0 0 2h1v1a1.0002 1.0002 0 0 0 1.7071.7071A1.0002 1.0002 0 0 0 21 7.5v-1h1a1 1 0 1 0 0-2Z"/>
  </SvgIcon>
}

export default LineCameraPlusIcon
